module.exports = __webpack_public_path__ + "img/phu_kien_oto.3f7d716a.svg";